import axios from 'axios';

export const axiosClient = axios.create({
  timeout: 10000,
  method: 'post',
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});
